class AccordionDetailsController {
  static ACCORDION_SELECTOR = '.accordion details';
  static CONTENT_SELECTOR = ':scope > summary + .accordion__content';
  static DURATION = 350;
  static EASING = 'ease';

  constructor(details) {
    this.details = details;
    this.summary = details.querySelector('summary');
    this.content = details.querySelector(AccordionDetailsController.CONTENT_SELECTOR);
    if (!this.summary || !this.content) return;

    this.isAnimating = false;
    this.summary.addEventListener('click', this.onClick.bind(this));
    this.summary.setAttribute('aria-expanded', details.hasAttribute('open'));
    this.details.classList.add('accordion-details--enabled');
  }

  onClick(event) {
    event.preventDefault();
    if (this.isAnimating) return;

    if (this.details.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isAnimating = true;
    this.details.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', 'true');

    this.content.style.overflow = 'hidden';
    this.content.style.height = '0px';

    requestAnimationFrame(() => {
      this.content.style.transition = `height ${AccordionDetailsController.DURATION}ms ${AccordionDetailsController.EASING}`;
      this.content.style.height = `${this.content.scrollHeight}px`;
    });

    this.onTransitionEnd(() => {
      this.resetInlineStyles();
      this.isAnimating = false;
    });
  }

  close() {
    this.isAnimating = true;
    this.summary.setAttribute('aria-expanded', 'false');

    this.content.style.overflow = 'hidden';
    this.content.style.height = `${this.content.scrollHeight}px`;

    requestAnimationFrame(() => {
      this.content.style.transition = `height ${AccordionDetailsController.DURATION}ms ${AccordionDetailsController.EASING}`;
      this.content.style.height = '0px';
    });

    this.onTransitionEnd(() => {
      this.details.removeAttribute('open');
      this.resetInlineStyles();
      this.isAnimating = false;
    });
  }

  onTransitionEnd(callback) {
    const handler = (event) => {
      if (event.target !== this.content || event.propertyName !== 'height') return;
      this.content.removeEventListener('transitionend', handler);
      callback();
    };
    this.content.addEventListener('transitionend', handler);
  }

  resetInlineStyles() {
    this.content.style.height = '';
    this.content.style.overflow = '';
    this.content.style.transition = '';
  }

  static init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    document.querySelectorAll(AccordionDetailsController.ACCORDION_SELECTOR).forEach((details) => {
      const content = details.querySelector(AccordionDetailsController.CONTENT_SELECTOR);
      if (content && !details.dataset.accordionInitialized) {
        details.dataset.accordionInitialized = 'true';
        new AccordionDetailsController(details);
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => AccordionDetailsController.init());
} else {
  AccordionDetailsController.init();
}

document.addEventListener('shopify:section:load', () => AccordionDetailsController.init());
